export default __webpack_public_path__ + "static/media/linkedIn_logo.a95afc06.png";